import http from "../../http"
import {API_V1_URL} from "../../constants/other"


const EQUIPMENT_URL = `${API_V1_URL}/equipment/`

export const getEquipment = (params, cancelToken) => http.get(EQUIPMENT_URL, {params}, {}, cancelToken)
